import type { SagaReturnType } from 'redux-saga/effects';
import { put, select, takeLatest } from 'redux-saga/effects';

import { api } from 'src/api';
import { getHotelId } from 'src/routes/Hotel/store/selectors/hotel';
import { INIT_APP } from '../view/constants';
import { setReviewsData } from './slice';

/**
 * Загрузить отзывы отеля
 */
function* getHotelReviews() {
  try {
    const hotelId: number = yield select(getHotelId);
    const response: SagaReturnType<typeof api.getReferencesHotelReviews> =
      yield api.getReferencesHotelReviews(hotelId);
    yield put(setReviewsData(response.reviews));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export default function* reviewSaga() {
  yield takeLatest(INIT_APP, getHotelReviews);
}
